<template>
  <div id="app">

      <router-view></router-view>

  </div>
</template>

<script>

import MainAppContainer from 'components/app/MainAppContainer.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'app',
  components: {
    MainAppContainer
  },
}
</script>

<style lang="scss">

    @import '~styles/data-table';
    @import '~styles/colors';
    @import '~styles/util';
    @import '~styles/list';
    @import '~styles/forms';
    @import '~styles/container';

    #app {
        display: flex;
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .h100 {
        height: 100%;
    }
</style>
